const CryptoJS = require("crypto-js");

function encryptData(data: any, id: any) {
    return CryptoJS.AES.encrypt(data, id).toString();
}

function decryptData(data: any, id: any) {
    const bytes = CryptoJS.AES.decrypt(data, id);
    const response = bytes.toString(CryptoJS.enc.Utf8);
    if (data && !response) {
        return data
    }
    return response
}


export default function useEncryption() {
    return { encryptData, decryptData }
}